import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';

import ConsultationCTA from 'Containers/ConsultationCTA';
import Typography from 'Components/Typography';

import map from 'lodash/fp/map';

import BlockLayout from './BlockLayout';

const styles = theme => ({
  root: {
    position: 'relative', // for the floating image
    opacity: 0,
    '& h1': {
      marginTop: 20,
      fontSize: 48,
      [theme.breakpoints.match('sm')]: {
        fontSize: 36,
      },
    },
    '& hr': {
      width: '100%',
      margin: '72px 0',
    },
  },
  visible: {
    opacity: 1,
    transition: 'opacity 300ms ease-in',
  },
  content: {
    [theme.breakpoints.match('sm')]: {
      fontSize: 20,
    },
  },
  gridItem: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridColumnGap: '30px',
    width: '100%',
    marginBottom: 72,
    '& p': {
      width: '100%',
      [theme.breakpoints.match('md')]: {
        maxWidth: 680,
        margin: 'auto',
      },
    },
    [theme.breakpoints.match('md')]: {
      display: 'block',
      marginBottom: 0,
    },
    [theme.breakpoints.match('sm')]: {
      display: 'block',
      marginBottom: 0,
    },
  },
});

const HowItWorks = ({ backgroundColor, classes, content, isMobileDevice }) => {
  const { title, primaryTitle, description, instructions } = content;
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <BlockLayout
      ref={ref}
      backgroundColor={backgroundColor}
      classes={{
        root: classNames(classes.root, {
          [classes.visible]: inView === true,
        }),
      }}
      contentAlign="center"
      contentWidth="veryWide"
    >
      <Typography align="center" color="white" paragraph variant="mono2">
        {title}
      </Typography>
      <Typography align="center" color="white" paragraph variant="h1">
        {primaryTitle}
      </Typography>
      <Typography align="center" color="white" variant="p1">
        {description}
      </Typography>
      <hr />
      <div className={classes.gridItem}>
        {map(
          ({ label, description: instruction }) => (
            <div key={instruction}>
              <Typography align="center" color="white" markupName="h2" paragraph variant="h1r">
                {label}
              </Typography>
              <Typography align="center" color="white" paragraph variant="p2">
                {instruction}
              </Typography>
              <br />
            </div>
          ),
          instructions
        )}
      </div>
      {!isMobileDevice && <ConsultationCTA dataFrom="block-how-it-works" theme="white" />}
    </BlockLayout>
  );
};

HowItWorks.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    ctaLabel: PropTypes.string,
    primaryTitle: PropTypes.string,
    description: PropTypes.string,
    instructions: PropTypes.array,
  }).isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
};

export default withStyles(styles)(HowItWorks);
